import React, { useEffect, useState } from 'react';
import { CurrencyField, DataTable } from '../../../commons/DataTable';
import GiveAndTakeLinkField from '../../../commons/DataTable/GiveAndTakeLinkField';
import { useTranslation } from 'react-i18next';
import { ContAffiliation, H5Styled } from '../../../styled-components';
import { Col, Row } from 'reactstrap';
import { formatCurrency } from '../../../lib/helpers/formatters';

function CommercialTable({ data, total, offset, limit, onFilter }) {
  const [t] = useTranslation('GIVE_AND_TAKE');
  const [giveData, setGiveData] = useState([]);
  const [allTotalsSum, setAllTotalsSum] = useState(0);

  useEffect(() => {
    let foundedData = data.filter((item) => item.type === 'COMMERCIAL');
    if (foundedData) {
      foundedData = foundedData.map((item) => {
        if (item.totals) {
          item.totals.total = item.totals.total - item.totals.insurances;
        }
        return item;
      });
    }
    setGiveData(foundedData);
    setAllTotalsSum(
      formatCurrency(
        foundedData
          .reduce((sum, item) => sum + (item.allTotals?.total || 0), 0)
          .toFixed(2)
      )
    );
  }, [data]);

  return (
    <>
      <ContAffiliation>
        <Row>
          <Col xs="12">
            <H5Styled>
              {t('COMMERCIAL_GIVE')} - totale competenze passive (commerciali):{' '}
              {allTotalsSum}
            </H5Styled>
          </Col>
        </Row>
        <br />
        <br />
        <DataTable
          data={giveData}
          total={total}
          offset={offset}
          limit={limit}
          onFilter={onFilter}
          emptyText={t('COMMON:NO_DATA')}
        >
          <CurrencyField
            title="Totale fatture"
            source="totals.invoices"
            className="txt-table-right"
            tooltip={t('TOTAL_COMMERCIAL_INVOICES_GIVE_TOOLTIP')}
          />
          <CurrencyField
            title="Totale"
            source="totals.total"
            className="txt-table-right"
          />
          <GiveAndTakeLinkField
            title="Dettagli"
            source="cumulativeFileUrl"
            className="text-left"
          />
        </DataTable>
      </ContAffiliation>
    </>
  );
}

export default CommercialTable;
